import { Group, Image, Stack, Text } from '@mantine/core'
import { IconBell } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { PreviewCard } from '@/components/deployments/deployment-editor/DeployPreview/PreviewCard'
import { EventEndpoint } from '@/types/deployment'
import { integrationConfig } from '../config'

type IntegrationPreviewCardProps = {
  eventEndpoints: EventEndpoint[]
}

export const IntegrationPreviewCard = ({
  eventEndpoints
}: IntegrationPreviewCardProps) => {
  return (
    <PreviewCard
      icon={<IconBell size={24} />}
      content={
        eventEndpoints.length === 0 ? (
          <Text ta="center" size="xs" c="dimmed">
            <FormattedMessage id="integrations.noEventNotifications" />
          </Text>
        ) : (
          <Stack gap={4} w="100%">
            {eventEndpoints.map((eventEndpoint) => (
              <Group key={eventEndpoint.service} gap="xs" wrap="nowrap">
                <Image
                  src={integrationConfig[eventEndpoint.service].logo}
                  w={24}
                  h={24}
                  fit="contain"
                />

                <Text size="xs" truncate>
                  <FormattedMessage
                    id={integrationConfig[eventEndpoint.service].name}
                  />
                </Text>
              </Group>
            ))}
          </Stack>
        )
      }
    />
  )
}
